<template>
  <form
    ref="form"
    data-url="/organizations"
    class="mb-0"
    :class="{ 'loading-opacity': preloader }"
  >
    <fieldset class="form-group">
      <div class="row">
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5 v-html="$store.getters.getTag('4.1')"></h5>
        </legend>

        <div class="col-12">
          <div class="row form-group">
            <label class="col-auto">¿Los datos son diferentes del Solicitante que declara en el numeral 1?</label>
            <app-input class="col-auto"
                       type="radio-buttons"
                       v-model="showForm"
                       :list="isActive"
            />
          </div>
        </div>
      </div>

        <div v-if="showForm" class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Nombre</label>
            <app-input
              type="text"
              v-model="inputs.name"
              placeholder="Ingrese su nombre"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Razón Social</label>
            <app-input
              type="text"
              placeholder="Ingrese la razon social"
              v-model="inputs.business_name"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>País</label>
            <app-input
              type="select"
              v-model="inputs.country_id"
              :required="true"
              :list="[
                { id: '', value: this.$t('select_option') },
                ...this.$store.state.common.countries,
              ]"
              :disabled="disabled"
            />
          </div>
        </div>

        <div
          class="col-md-6"
          v-if="inputs.country_id && provinceList.length <= 1"
        >
          <div class="form-group">
            <label>Ciudad</label>
            <app-input
              type="text"
              v-model="inputs.city"
              placeholder="Ingrese la ciudad"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="provinceList.length > 1">
          <div class="form-group mb-2 mb-md-0">
            <label>Provincia</label>
            <app-input
              type="select"
              v-model="inputs.province_id"
              :required="true"
              :list="[
                { id: '', value: this.$t('select_option') },
                ...provinceList,
              ]"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6" v-if="provinceList.length > 1">
          <div class="form-group mb-2 mb-md-0">
            <label>Ciudad</label>
            <app-input
              type="select"
              v-model="inputs.canton_id"
              :required="true"
              :list="[
                { id: '', value: this.$t('select_option') },
                ...cantonList,
              ]"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-2 mb-md-0">
            <label>Dirección</label>
            <app-input
              type="textarea"
              v-model="inputs.address"
              :required="true"
              :disabled="disabled"
              placeholder="Ingrese la dirección"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Responsable</label>
            <app-input
              type="text"
              v-model="inputs.legal_representative"
              placeholder="Ingrese el responsable"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Teléfono</label>
            <app-input
              type="tel-input"
              v-model="inputs.phone"
              placeholder="Ingrese su numero de telefono"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>E-mail</label>
            <app-input
              type="email"
              v-model="inputs.email"
              placeholder="Ingrese su email"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Pág. Web</label>
            <app-input
              type="text"
              v-model="inputs.web"
              placeholder="Ingrese su pagina web"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div
          class="col-12"
        >
          <div class="form-group mb-2 mb-md-0">
            <label>Actividad Principal</label>
            <app-input
              type="textarea"
              v-model="inputs.main_activity"
              :required="true"
              :disabled="disabled"
              placeholder="Ingrese la actividad principal"
            />
          </div>
        </div>

        <div class="col-12 mt-3" v-if="!disabled">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </fieldset>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  mixins: [FormMixin],
  props: {
    disabled: Boolean,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      provinceList: [],
      cantonList: [],
      showForm: 0,
      isActive: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ]
    };
  },
  created() {
    this.data();
  },
  watch: {
    "inputs.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.country_id
      );
    },

    "inputs.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(this.inputs.province_id);
    },

    "$store.state.common.countries": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.country_id
      );
      this.cantonList = this.$store.getters.getCantons(this.inputs.province_id);
    },
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      this.inputs.acc_app_id = this.$store.state.accreditation.id;
      this.inputs.establishment_type = "P";
      this.save({ org: this.inputs });
    },

    afterSuccess(response) {
      // this.$toastr.s(res.data.message);
      this.inputs = response.data.org;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.preloader = true;

      this.axiosGet(
        `/organizations/parent?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.inputs = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
